import gql from "graphql-tag";

export default gql`mutation CreateFileEvent($id:Int!, $eventtypeid:Int!, $customdate:Date!) {
    createFileEvent(id:$id, eventtypeid:$eventtypeid, customdate:$customdate) {
        id
    }
  }`